import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './quiz-qa.component.scss';
var QuizQa = /** @class */ (function (_super) {
    tslib_1.__extends(QuizQa, _super);
    function QuizQa(element) {
        return _super.call(this, element) || this;
    }
    QuizQa.prototype.init = function () {
        this.buttons = Array.from(this.element.querySelectorAll('.quiz-qa__buttons--item'));
        this.containerCorrect = this.element.querySelector('.quiz-qa__result--correct');
        this.containerIncorrect = this.element.querySelector('.quiz-qa__result--incorrect');
    };
    QuizQa.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttons) {
            this.buttons.map(function (button) { return button.addEventListener('click', function (event) {
                _this.clearButtons();
                var element = undefined;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var outcome = element.getAttribute('data-outcome');
                if (outcome === 'correct') {
                    element.classList.remove('incorrect');
                    element.classList.add('correct');
                    _this.containerIncorrect.classList.add('d-none');
                    _this.containerCorrect.classList.remove('d-none');
                }
                else {
                    element.classList.remove('correct');
                    element.classList.add('incorrect');
                    _this.containerCorrect.classList.add('d-none');
                    _this.containerIncorrect.classList.remove('d-none');
                }
            }); });
        }
    };
    QuizQa.prototype.clearButtons = function () {
        if (this.buttons) {
            this.buttons.map(function (button) {
                button.classList.remove('correct');
                button.classList.remove('incorrect');
            });
        }
    };
    return QuizQa;
}(Base));
export { QuizQa };



//////////////////
// WEBPACK FOOTER
// ./components/quiz-qa/quiz-qa.component.ts
// module id = 737
// module chunks = 0